// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"6051":"css/admin-app.6786","6727":"css/app.6786"}[chunkId] + ".css";
};